import React from 'react';
import { Field } from 'redux-form/immutable';
import RaisedButton from 'material-ui/RaisedButton';
import { validateConstraints, validationImmutableReduxForm } from '../../../components/FormWrapper';
import { Col, Row } from 'react-flexbox-grid';

import { TextField } from 'redux-form-material-ui';

const formValidation = values =>
    validateConstraints(values.toJS(), {
        endpointPrefix: {
            presence: {
                message: '^Bitte geben Sie einen Mandanten ein',
                allowEmpty: false,
            },
        },
        email: {
            presence: {
                message: '^Bitte geben Sie eine E-Mail-Adresse ein',
                allowEmpty: false,
            },
        },
    });

const ResetPasswordForm = props => {
    const { handleSubmit, pristine, reset, submitting } = props;
    return (
        <form onSubmit={handleSubmit}>
            <div className="form_container">
                <Row>
                    <Col xs={12}>
                        <Field
                            name="endpointPrefix"
                            component={TextField}
                            type="text"
                            floatingLabelText="Mandant"
                            label="Mandant"
                            style={{ width: '100%' }}
                        />
                        <br />
                        <Field
                            name="email"
                            component={TextField}
                            type="text"
                            floatingLabelText="E-Mail-Adresse"
                            style={{ width: '100%' }}
                            label="E-Mail-Adresse"
                        />
                    </Col>
                </Row>
            </div>
            <br />
            <Row>
                <Col xs={12} className="form_container">
                    <Row end="xs">
                        <Col xs={5}>
                            <RaisedButton
                                label="Passwort zurücksetzen"
                                primary={true}
                                type="submit"
                                disabled={props.isLoading}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </form>
    );
};

export default validationImmutableReduxForm('resetPasswordForm', formValidation)(ResetPasswordForm);
